"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth0_react_1 = require("@auth0/auth0-react");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const ecommerce_1 = require("../../../api/ecommerce");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const GlobalModal_1 = require("../../../common/js/components/GlobalModal");
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const ScopeGuard_1 = __importDefault(require("../../../common/js/components/security/ScopeGuard"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const translation_1 = require("../../../common/js/helper/translation");
const withAuthorization_1 = __importDefault(require("../../../common/js/hoc/withAuthorization"));
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const SearchInput_1 = __importDefault(require("../../atoms/SearchInput"));
const UserProfileContactPerson_1 = __importDefault(require("../../atoms/UserProfileContactPerson"));
const ContactPersonStore_1 = __importDefault(require("../../stores/ContactPersonStore"));
const ChangeRequestModal_1 = __importDefault(require("../ChangeRequestModal"));
class UserProfileAdministration extends react_1.default.Component {
    contextReactionDisposer;
    searchTerm = '';
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            searchTerm: mobx_1.observable,
            contacts: mobx_1.computed,
            onClearSearchInput: mobx_1.action.bound,
        });
    }
    componentDidMount() {
        document.title = (0, translation_1.t)('profile_subpage_title', { title: (0, translation_1.t)('user.profile.administration.title') });
        this.contextReactionDisposer = (0, mobx_1.reaction)(() => AuthorizationStore_1.default.customerId, () => {
            ContactPersonStore_1.default.loadContactPersons();
        }, { fireImmediately: true });
    }
    componentWillUnmount() {
        this.contextReactionDisposer?.();
    }
    get contacts() {
        const list = ContactPersonStore_1.default.customerList;
        if (this.searchTerm.trim() === '') {
            return list;
        }
        const regex = new RegExp(this.searchTerm.trim().replace(/\s+/g, '|'), 'i');
        return list.filter((contact) => regex.test(contact.firstName) || regex.test(contact.lastName) || regex.test(contact.email));
    }
    render() {
        if (ContactPersonStore_1.default.isLoading) {
            return (react_1.default.createElement("section", { className: "znd-user-profile-page__content" },
                react_1.default.createElement("div", { className: "my-4" },
                    react_1.default.createElement(LoadingSpinner_1.default, { center: true }))));
        }
        return (react_1.default.createElement("section", { className: "znd-user-profile-page__content" },
            react_1.default.createElement("div", { className: "align-items-center justify-content-between znd-user-profile-page__header" },
                react_1.default.createElement("div", { className: "znd-user-profile-page__administration-title" },
                    react_1.default.createElement("h2", { className: "znd-user-profile-page__content-data-title m-0 t-headline-3" }, (0, translation_1.t)('user.profile.administration.title')),
                    react_1.default.createElement("div", { className: "znd-user-profile-page__subtitle" }, (0, translation_1.t)('user.profile.administration.subtitle'))),
                react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.ACCOUNT_CREATE] },
                    react_1.default.createElement(Button_1.default, { className: "znd-user-profile-page__add-button", text: (0, translation_1.t)('user.profile.administration.add_user.btn'), variant: ButtonVariant_1.default.primary, icon: Zupicons_1.default.plus, onClick: () => {
                            (0, GlobalModal_1.showModal)({
                                component: ChangeRequestModal_1.default,
                                props: {
                                    title: (0, translation_1.t)('user.profile.administration.title'),
                                    topic: ecommerce_1.ChangeRequestTopicEnum.Contact,
                                    object: ecommerce_1.ChangeRequestObjectEnum.PersonalContact,
                                    edit: false,
                                    onDoneLabel: (0, translation_1.t)('change_request_modal.personal_contact.on_done_label'),
                                },
                            }).then(() => {
                                ContactPersonStore_1.default.loadContactPersons();
                            });
                        } })),
                react_1.default.createElement(SearchInput_1.default, { className: "znd-user-profile-page__administration-search", value: this.searchTerm, onChange: (event) => {
                        this.searchTerm = event.target.value;
                    }, onClear: this.onClearSearchInput, placeholder: (0, translation_1.t)('user.profile.administration.search_placeholder') })),
            react_1.default.createElement("div", { className: "znd-user-profile-page__content-data-group" }, this.renderResultContacts(this.contacts))));
    }
    renderResultContacts(contacts) {
        if (contacts.length <= 0) {
            return react_1.default.createElement("div", { className: "w-100 text-center mt-5" }, (0, translation_1.t)('user.profile.administration.not_found'));
        }
        return contacts.map((customer) => (react_1.default.createElement(UserProfileContactPerson_1.default, { key: customer.id, className: "znd-user-profile-page__content-data-item", title: (0, translation_1.t)('user.profile.account.title'), contactPerson: {
                id: customer.id,
                department: customer.extensions?.massiveCustomer?.department ?? undefined,
                email: customer.email,
                externalId: customer.extensions?.massiveCustomer?.externalId ?? undefined,
                name1: customer.lastName,
                name2: customer.firstName,
                phoneNumber1: customer.extensions?.massiveCustomer?.phoneNumber1 ?? undefined,
                phoneNumber2: customer.extensions?.massiveCustomer?.phoneNumber2 ?? undefined,
                salutation: customer.salutation?.salutationKey,
                role: customer.extensions?.massiveCustomer?.role ?? undefined,
            } })));
    }
    onClearSearchInput() {
        this.searchTerm = '';
    }
}
exports.default = (0, auth0_react_1.withAuth0)((0, withAuthorization_1.default)({ scope: AuthorizationScopes_1.default.ACCOUNT_READ })((0, mobx_react_1.observer)(UserProfileAdministration)));
